<template>
  <div id="dashboard-analytics">
    <div class="vx-row">
      <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap">
           <!-- <vs-button class="ml-auto" color="primary" icon-pack="feather" icon="icon-plus" @click="addNewBudget">New
              Budget</vs-button>-->
          </div>
        <vx-card title="List of Budget" class="mb-4">
          <!-- Indicateur de chargement ou message de feedback -->
          <div v-if="loading" class="text-center my-4">
            Loading...
          </div>
          <div v-else>
            <div v-if="budgets.length === 0" class="text-center text-red-500">
              No budgets found.
            </div>

            <vs-table v-else :data="budgets" :loading="loading" class="table-dark-inverted" style="width: 100%">
              <template slot="thead">
                <vs-th>Name</vs-th>
                <vs-th>Created At</vs-th>
                <vs-th>Updated At</vs-th>
                <vs-th>Display</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="indextrr" v-for="(tr, indextrr) in data">
                  <vs-td>
                    <span style="color:black"> {{ tr.name }} </span>
                  </vs-td>
                  <vs-td>
                    <span style="color:black"> {{ format_date(tr.createdAt) }}</span>
                  </vs-td>
                  <vs-td>
                    <span style="color:black"> {{ format_date(tr.updatedAt) }}</span>
                  </vs-td>
                  <vs-td>
                    <feather-icon icon="EyeIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="displayBudget(tr.id)" />
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import axios from "@/axios.js";
export default {
  components: {
  },
  data() {
    return {
      loading: false, // Indique l'état de chargement
      budgets: [], // Stocke les budgets filtrées
    };
  },
  created() {
    const roles = localStorage.getItem("login-roles");
    if (roles) {
      const rolesLower = roles.toLowerCase();
      if (rolesLower.includes("accountant")) {
        this.$router.push({ path: "/outlay/outlay-list" });
      }
      if (rolesLower.includes("admin")) {
        this.fetchbudgets();
      } else {
        this.$vs.notify({
          title: "Denied",
          text: "Access to the Finance page is reserved for administrators",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "bottom-right",
          time: 8000,
        });
        this.$router.push({ path: "/dashboard/analytics" });
      }
    } else {
      this.$vs.notify({
        title: "Erreur",
        text: "Roluri de autentificare lipsă.",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger",
        position: "bottom-right",
        time: 8000,
      });
      this.$router.push({ path: "/login" });
    }
  },
  methods: {
    format_date(value, withhour) {
      if (value) {
        if (withhour)
          return moment(String(value)).format("DD MMM YYYY HH:mm:ss");
        else return moment(String(value)).add(6, 'hours').format("DD MMM YYYY");
      }
    },
    addNewBudget() {

    },
    displayBudget (id) {
        this.$router.push("/budgetv2/" + id).catch(() => {})
    },
    async fetchbudgets() {
      this.loading = true;
      try {
        const response = await axios.get('budgets/data/');
        this.budgets = response.data;
      } catch (error) {
        console.error('Erreur lors de la récupération des budgets:', error);
        this.$vs.notify({
          title: "Erreur",
          text: "Impossible de récupérer les budgets.",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
          position: "bottom-right",
          time: 8000,
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>